import React, { FC } from 'react';
//import { useSelector } from 'react-redux';
//import { RootState } from '../../redux/rootReducer';
import ParseHtml from '../common/ParseHtml';
import withLocalization from '../hoc/withLocalization';
import { replacePlaceholder, removeDecimalPart } from '../../util/CommonLogic';
import step1Icon from '../../features/siteTheme/Brands/tmvcs/logo/step1-icon.svg';
import step2Icon from '../../features/siteTheme/Brands/tmvcs/logo/step2-icon.svg';
import step3Icon from '../../features/siteTheme/Brands/tmvcs/logo/step3-icon.svg';
import './PackageBottomDetails.scss';

interface SearchPanelProps {
  localize?: any;
  //localizeImages?: any;
  offersData?: any;
  depositeAmt: any;
}
const PackageBottomDetails: FC<SearchPanelProps> = (props: SearchPanelProps) => {
  const { localize, offersData, depositeAmt } = props;
  //const { localize, localizeImages, depositeAmt } = props;
  /*const step1Img = localizeImages('preview-sales-engine.static-content.images.step-1-icon', 0, '1:1');
  const step2Img = localizeImages('preview-sales-engine.static-content.images.step-2-icon', 0, '1:1');
  const step3Img = localizeImages('preview-sales-engine.static-content.images.step-3-icon', 0, '1:1');
  const stIcon1 = step1Img?.path || '';
  const stIcon2 = step2Img?.path || '';
  const stIcon3 = step3Img?.path || '';*/
  const st1_desc = localize('preview-sales-engine.static-content.copy.pbeo.step-1-description');
  const symbol = localize('preview-sales-engine.static-content.copy.pbeo.intl.usd-label');
  const minCost = offersData?.minimumStartingCost || '';
  const minCostArr = minCost.split('$');
  const MinVal = minCostArr && minCostArr[1] ? removeDecimalPart(minCostArr[1]) : '';
  const updateDeposite = removeDecimalPart(depositeAmt) || '';
  const splitDeposite = updateDeposite?.split('$');
  const subAmt = parseInt(MinVal) - parseInt(splitDeposite[1]);
  const chkAmt = subAmt < 1;
  const showDepositAmt = `${symbol}${splitDeposite[1]}`;
  const updated_st1_desc = replacePlaceholder(st1_desc, '{0}', showDepositAmt);
  const claimToday = localize('preview-sales-engine.static-content.copy.pbeo.intl.step-1-full-payment-req-description');
  const updateClaim = replacePlaceholder(claimToday, 'US$%s', showDepositAmt);
  const refineBtnText = chkAmt ? updateClaim : updated_st1_desc;
  const updateStep3 = chkAmt
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.intl-step-3-description')
    : localize('preview-sales-engine.static-content.copy.pbeo.step-3-description');

  return (
    <>
      <div className="pkgInfo-bottom-section">
        <div className="packageInfoBtm-content">
          <div className="packageBtm-header-container">
            <span className="packageBtm-header-title">
              <ParseHtml
                htmlInput={localize('preview-sales-engine.static-content.copy.pbeo.ready-to-vacation-section-header')}
              ></ParseHtml>
            </span>
            <div className="pkg-details-btm-bar"></div>

            <span className="packageBtm-header-desc">
              <ParseHtml
                htmlInput={localize(
                  'preview-sales-engine.static-content.copy.pbeo.ready-to-vacation-section-description',
                )}
              ></ParseHtml>
            </span>
          </div>
          <div className="packageBtm-group-container">
            <div className="packageBtm-group-list">
              <div className="intl-step1-baseImg">
                <img src={step1Icon} alt="error" className="intl-list-cl-step1" />
              </div>

              <div className="pkgBtm-list-grpText">
                <span className="pkgBtmgrpText-step">
                  <ParseHtml
                    htmlInput={localize('preview-sales-engine.static-content.copy.pbeo.step-1-label')}
                  ></ParseHtml>
                </span>
                <span className="pkgBtmgrpText-step-desc">
                  <ParseHtml htmlInput={refineBtnText}></ParseHtml>
                </span>
              </div>
            </div>
            <div className="packageBtm-group-list">
              <div className="intl-step2-baseImg">
                <img src={step2Icon} alt="error" className="intl-list-cl-step2" />
              </div>
              <div className="pkgBtm-list-grpText">
                <span className="pkgBtmgrpText-step">
                  <ParseHtml
                    htmlInput={localize('preview-sales-engine.static-content.copy.pbeo.step-2-label')}
                  ></ParseHtml>
                </span>
                <span className="pkgBtmgrpText-step-desc">
                  <ParseHtml
                    htmlInput={localize('preview-sales-engine.static-content.copy.pbeo.step-2-description')}
                  ></ParseHtml>
                </span>
              </div>
            </div>
            <div className="packageBtm-group-list">
              <div className="intl-step3-baseImg">
                <img src={step3Icon} alt="error" className="intl-list-cl-step3" />
              </div>
              <div className="pkgBtm-list-grpText">
                <span className="pkgBtmgrpText-step">
                  <ParseHtml
                    htmlInput={localize('preview-sales-engine.static-content.copy.pbeo.step-3-label')}
                  ></ParseHtml>
                </span>
                <span className="pkgBtmgrpText-step-desc">
                  <ParseHtml htmlInput={updateStep3}></ParseHtml>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default withLocalization(PackageBottomDetails);
